import { AlertaPerguntaSimOuNaoBooleano, AlertaSimples } from '@/helpers/MensagemHelper';
import { getToken, getUserPermissions } from '@/utils/Token';
import Vue from 'vue';
import VueRouter, { NavigationGuardNext, Route, RouteConfig } from 'vue-router';
import PermissoesPadrao from '@/constants/enums/PermissoesPadrao';

Vue.use(VueRouter);

const routes = [
  {
    path: '*',
    redirect: '/notfound-404',
  },
  {
    path: '/',
    redirect: '/login',
  },
  {
    path: '/',
    redirect: '/recuperar-senha',
  },
  {
    path: '/confirma-email',
    name: 'confirmaEmail',
    component: () => import('../views/emails/ConfirmaEmail.vue'),
  },
  // Rota para inserir a nova definição de senha
  {
    path: '/redefinir-senha',
    name: 'redefinirSenha',
    component: () => import('../views/emails/RedefinirSenha.vue'),
  },
  // Rota para enviar email de recuperação de senha
  {
    path: '/recuperar-senha',
    name: 'recuperarSenha',
    component: () => import('../views/emails/RecuperarSenha.vue'),
  },
  {
    path: '/confirma-agendamento/:token',
    name: 'confirmaAgendamento',
    component: () => import('../views/confirmaAgendamento/ConfirmaAgendamento.vue'),
  },
  {
    path: '/loginPaciente',
    name: 'loginPaciente',
    component: () => import('../views/paciente/loginPaciente.vue'),
  },
  {
    // J5 — LGPD: portal de transparência de acessos (gated pelo token assinado, sem auth).
    path: '/meus-acessos',
    name: 'meusAcessos',
    component: () => import('../views/paciente/meusAcessos.vue'),
  },
  {
    // C5 — NPS: resposta pública da pesquisa de satisfação (gated pelo token assinado, sem auth).
    path: '/responder-nps',
    name: 'responderNps',
    component: () => import('../views/publico/ResponderNps.vue'),
  },
  {
    // C8 — Prontuário compartilhado: resumo público read-only (gated pelo token assinado, sem auth).
    path: '/prontuario-compartilhado',
    name: 'prontuarioCompartilhado',
    component: () => import('../views/publico/ProntuarioCompartilhado.vue'),
  },
  {
    // C3 — Adesão: confirmação pública das doses do dia (gated pelo token assinado, sem auth).
    path: '/confirmar-doses',
    name: 'confirmarDoses',
    component: () => import('../views/publico/ConfirmarDoses.vue'),
  },
  {
    // B1 — Anamnese pré-consulta: formulário público do paciente (gated pelo token assinado, sem auth).
    path: '/responder-anamnese',
    name: 'responderAnamnese',
    component: () => import('../views/publico/ResponderAnamnese.vue'),
  },
  {
    // F1 — Telemedicina: sala de vídeo pública do paciente (gated pelo token assinado, sem auth).
    path: '/teleconsulta',
    name: 'teleconsulta',
    component: () => import('../views/publico/Teleconsulta.vue'),
  },
  {
    path: '/cadastroPaciente',
    name: 'cadastroPaciente',
    component: () => ('../views/paciente/cadastroPaciente.vue'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login/Login.vue'),
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('../views/home/Home.vue'),
    meta: { auth: true },
  },
  {
    path: '/pacientes',
    name: 'pacientes',
    component: () => import('../views/paciente/ListaPacientes.vue'),
    meta: {
      auth: true,
      permissions: [
        PermissoesPadrao.PacienteReadAll,
      ],
    },
  },
  {
    path: '/paciente/:pacienteId?',
    name: 'pacientesForm',
    component: () => import('../views/paciente/formPacientes.vue'),
    meta: {
      auth: true,
      permissions: [
        PermissoesPadrao.PacienteCreate,
        PermissoesPadrao.PacienteDelete,
      ],
    },
  },
  {
    path: '/paciente/:pacienteId?',
    name: 'pacientesFormUpdate',
    component: () => import('../views/paciente/formPacientes.vue'),
    meta: {
      auth: true,
      permissions: [
        PermissoesPadrao.PacienteUpdate,
      ],
    },
  },
  {
    path: '/paciente/visualizar/:pacienteId',
    name: 'pacientesFormView',
    component: () => import('../views/paciente/formPacientes.vue'),
    meta: {
      auth: true,
      permissions: [
        PermissoesPadrao.PacienteRead,
      ],
    },
  },
  {
    path: '/paciente/:pacienteId/curva-crescimento',
    name: 'curvaCrescimento',
    component: () => import('../views/paciente/CurvaCrescimentoView.vue'),
    meta: {
      auth: true,
      permissions: [
        PermissoesPadrao.PacienteRead,
      ],
    },
  },
  {
    path: '/convenios',
    name: 'convenios',
    component: () => import('../views/convenio/ListaConvenio.vue'),
    meta: {
      auth: true,
      permissions: [
        PermissoesPadrao.ConvenioReadAll,
      ],
    },
  },
  {
    path: '/convenio/:id?',
    name: 'conveniosForm',
    component: () => import('../views/convenio/formConvenio.vue'),
    meta: {
      auth: true,
      permissions: [
        PermissoesPadrao.ConvenioCreate,
        PermissoesPadrao.ConvenioUpdate,
      ],
    },
  },
  {
    path: '/convenio/:id?',
    name: 'conveniosFormUpdate',
    component: () => import('../views/convenio/formConvenio.vue'),
    meta: {
      auth: true,
      permissions: [
        PermissoesPadrao.ConvenioUpdate,
      ],
    },
  },
  {
    path: '/convenio/visualizar/:id',
    name: 'conveniosFormView',
    component: () => import('../views/convenio/formConvenio.vue'),
    meta: {
      auth: true,
      permissions: [
        PermissoesPadrao.ConvenioRead,
      ],
    },
  },
  {
    path: '/agenda',
    name: 'Agenda',
    component: () => import('../views/agenda/Agenda.vue'),
    meta: {
      auth: true,
      permissions: [
        PermissoesPadrao.AgendaCreate,
        PermissoesPadrao.AgendaDelete,
        PermissoesPadrao.AgendaRead,
        PermissoesPadrao.AgendaReadAll,
        PermissoesPadrao.AgendaUpdate,
        PermissoesPadrao.AgendamentoCreate,
        PermissoesPadrao.AgendamentoDelete,
        PermissoesPadrao.AgendamentoRead,
        PermissoesPadrao.AgendamentoUpdate,
      ],
    },
  },
  {
    path: '/clinicas',
    name: 'clinicas',
    component: () => import('../views/multiTenancy/listaClinica.vue'),
    meta: {
      auth: true,
      permissions: [
        PermissoesPadrao.TenantReadAll,
        PermissoesPadrao.TenantRead,
        PermissoesPadrao.ClinicaRead,
      ],
    },
  },
  {
    path: '/clinica/:id?',
    name: 'clinicasForm',
    component: () => import('../views/multiTenancy/formClinica.vue'),
    meta: {
      auth: true,
      permissions: [
        PermissoesPadrao.TenantCreate,
        PermissoesPadrao.TenantUpdate,
        PermissoesPadrao.TenantDelete,
        PermissoesPadrao.ClinicaRead,
        PermissoesPadrao.ClinicaUpdate,
      ],
    },
  },
  {
    path: '/clinica/:id?',
    name: 'clinicasFormUpdate',
    component: () => import('../views/multiTenancy/formClinica.vue'),
    meta: {
      auth: true,
      permissions: [
        PermissoesPadrao.TenantUpdate,
        PermissoesPadrao.ClinicaUpdate,
        PermissoesPadrao.TenantPatch,
      ],
    },
  },
  {
    path: '/clinica/visualizar/:id',
    name: 'clinicasFormView',
    component: () => import('../views/multiTenancy/formClinica.vue'),
    meta: {
      auth: true,
      permissions: [
        PermissoesPadrao.TenantRead,
        PermissoesPadrao.ClinicaRead,
      ],
    },
  },
  {
    path: '/atendimentos',
    name: 'atendimentos',
    component: () => import('../views/atendimento/ListaAtendimentos.vue'),
    meta: {
      auth: true,
      permissions: [
        PermissoesPadrao.AtendimentoReadAll,
      ],
    },
  },
  {
    path: '/atendimento/:pacienteId/:agendamentoId',
    name: 'atendimentoForm',
    component: () => import('../views/atendimento/Atendimento.vue'),
    meta: {
      auth: true,
      permissions: [
        PermissoesPadrao.AtendimentoCreate,
        PermissoesPadrao.AtendimentoUpdate,
      ],
    },
  },
  {
    path: '/atendimento/editar/:pacienteId/:idAtendimento',
    name: 'atendimentoFormUpdate',
    component: () => import('../views/atendimento/Atendimento.vue'),
    meta: {
      auth: true,
      permissions: [
        PermissoesPadrao.AtendimentoUpdate,
      ],
    },
  },
  {
    path: '/revisoes',
    name: 'revisoes',
    component: () => import('../views/atendimento/ListaAtendimentos.vue'),
    meta: {
      auth: true,
      permissions: [
        PermissoesPadrao.AtendimentoReadAll,
        PermissoesPadrao.PacienteRead,
      ],
    },
  },
  {
    path: '/imunizacao',
    name: 'imunizacao',
    component: () => import('../views/imunizacao/ListaImunizacao.vue'),
    meta: {
      auth: true,
      permissions: [
        PermissoesPadrao.PacienteReadAll,
      ],
    },
  },
  {
    path: '/imunizacao/cartao/:pacienteId',
    name: 'cartaoVacinas',
    component: () => import('../views/imunizacao/CartaoVacinas.vue'),
    meta: {
      auth: true,
      permissions: [
        PermissoesPadrao.PacienteRead,
      ],
    },
  },
  {
    path: '/imunizacao/configuracao',
    name: 'configuracaoVacinas',
    component: () => import('../views/imunizacao/ConfiguracaoVacinas.vue'),
    meta: {
      auth: true,
      permissions: [
        PermissoesPadrao.PacienteRead,
      ],
    },
  },
  {
    path: '/visualizar/revisao/:pacienteId',
    name: 'atendimentoRevisaoFormView',
    component: () => import('../views/atendimento/ListaRevisoes.vue'),
    meta: {
      auth: true,
      permissions: [
        PermissoesPadrao.AtendimentoReadAll,
        PermissoesPadrao.PacienteRead,
      ],
    },
  },
  {
    path: '/usuarios',
    name: 'usuarios',
    component: () => import('../views/usuario/ListaUsuarios.vue'),
    meta: {
      auth: true,
      permissions: [
        PermissoesPadrao.UsuarioReadAll,
      ],
    },
  },
  {
    path: '/usuario/:id?',
    name: 'usuario',
    component: () => import('../views/usuario/FormUsuario.vue'),
    meta: {
      auth: true,
      permissions: [
        PermissoesPadrao.UsuarioCreate,
        PermissoesPadrao.UsuarioUpdate,
        PermissoesPadrao.UsuarioDelete,
      ],
    },
  },
  {
    path: '/usuario/visualizar/:id',
    name: 'visualizarUsuario',
    component: () => import('../views/usuario/FormUsuario.vue'),
    meta: {
      auth: true,
      permissions: [
        PermissoesPadrao.UsuarioRead,
      ],
    },
  },
  {
    path: '/usuario/:id',
    name: 'editarUsuario',
    component: () => import('../views/usuario/FormUsuario.vue'),
    meta: {
      auth: true,
      permissions: [
        PermissoesPadrao.UsuarioUpdate,
      ],
    },
  },
  {
    path: '/seu-perfil',
    name: 'perfilDoUsuario',
    component: () => import('../views/usuario/FormUsuario.vue'),
    meta: {
      auth: true,
      permissions: [
        PermissoesPadrao.ProfileUpdate,
      ],
    },
  },

  {
    path: '/impressos-personalizados',
    name: 'impressosPersonalizados',
    component: () => import('../views/impressosPersonalizados/ListaImpressosPersonalizados.vue'),
    meta: {
      auth: true,
      permissions: [
        PermissoesPadrao.ImpressoPersonalizadoReadAll,
      ],
    },
  },
  {
    path: '/impressos-personalizados',
    name: 'impressosPersonalizados',
    component: () => import('../views/impressosPersonalizados/ListaImpressosPersonalizados.vue'),
    meta: {
      auth: true,
      permissions: [
        PermissoesPadrao.ImpressoPersonalizadoReadAll,
      ],
    },
  },
  {
    path: '/impresso-personalizado/:id?',
    name: 'impressosPersonalizadosFormUpdate',
    component: () => import('../views/impressosPersonalizados/FormImpressoPersonalizado.vue'),
    meta: {
      auth: true,
      permissions: [
        PermissoesPadrao.ImpressoPersonalizadoCreate,
        PermissoesPadrao.ImpressoPersonalizadoUpdate,
      ],
    },
  },

  {
    path: '/impresso-personalizado/visualizar/:impressoPersonalizadoId',
    name: 'impressoPersonalizadoFormView',
    component: () => import('../views/impressosPersonalizados/FormImpressoPersonalizado.vue'),
    meta: {
      auth: true,
      permissions: [
        PermissoesPadrao.ImpressoPersonalizadoRead,
      ],
    },
  },

  {
    path: '/consultas-personalizadas',
    name: 'consultasPersonalizadas',
    component: () => import('../views/consultasPersonalizadas/ListaConsultasPersonalizadas.vue'),
    meta: { auth: true },
  },
  {
    path: '/quadros-customizados',
    name: 'quadrosCustomizados',
    component: () => import('../views/quadrosCustomizados/ListaQuadrosCustomizados.vue'),
    meta: { auth: true },
  },
  {
    path: '/triagens',
    name: 'triagens',
    component: () => import('../views/triagem/ListaTriagem.vue'),
    meta: {
      auth: true,
      permissions: [
        PermissoesPadrao.AcessoTriagem,
        PermissoesPadrao.TriagemReadAll,
      ],
    },
  },
  {
    path: '/triagens/:pacienteId/:agendamentoId',
    name: 'triagensForm',
    component: () => import('../views/triagem/FormTriagem.vue'),
    meta: {
      auth: true,
      permissions: [
        PermissoesPadrao.AcessoTriagem,
        PermissoesPadrao.TriagemRead,
        PermissoesPadrao.TriagemCreate,
      ],
    },
  },
  {
    path: '/triagens/visualizar/:pacienteId/:agendamentoId',
    name: 'triagensFormView',
    component: () => import('../views/triagem/FormTriagem.vue'),
    meta: {
      auth: true,
      permissions: [
        PermissoesPadrao.AcessoTriagem,
        PermissoesPadrao.TriagemRead,
      ],
    },
  },
  {
    path: '/logs-auditoria',
    name: 'logsAuditoria',
    component: () => import('../views/auditoria/logsAuditoria.vue'),
    meta: {
      auth: true,
      permissions: [
        PermissoesPadrao.AuditoriaReadAll,
      ],
    },
  },

  {
    path: '/notfound-404',
    name: 'NotFound',
    component: () => import('../views/rotaPadrao/NotFound.vue'),
    meta: {
      auth: true,
      permissions: [
        PermissoesPadrao.ImpressoPersonalizadoReadAll,
      ],
    },
  },
  {
    path: '/impresso-personalizado/:id?',
    name: 'impressosPersonalizadosForm',
    component: () => import('../views/impressosPersonalizados/FormImpressoPersonalizado.vue'),
    meta: {
      auth: true,
      permissions: [
        PermissoesPadrao.ImpressoPersonalizadoCreate,
        PermissoesPadrao.ImpressoPersonalizadoUpdate,
      ],
    },
  },
  {
    path: '/impresso-personalizado/visualizar/:impressoPersonalizadoId',
    name: 'impressoPersonalizadoFormView',
    component: () => import('../views/impressosPersonalizados/FormImpressoPersonalizado.vue'),
    meta: {
      auth: true,
      permissions: [
        PermissoesPadrao.ImpressoPersonalizadoRead,
      ],
    },
  },
  {
    path: '/importacao',
    name: 'importacao',
    component: () => import('../views/importacao/Importacao.vue'),
    meta: { auth: true },
    permissions: [
      PermissoesPadrao.AcessoImportacaoPlanilha,
    ],
  },
  {
    path: '/configuracoes',
    name: 'configuracoes',
    component: () => import('../views/configuracoes/ConfiguracoesWrapper.vue'),
    meta: { auth: true },
    children: [
      {
        path: 'tipos-de-consulta',
        name: 'configuracoesTiposDeConsultaView',
        component: () => import('../views/configuracoes/TiposDeConsulta.vue'),
        meta: {
          auth: true,
          permissions: [
            PermissoesPadrao.ImpressoPersonalizadoRead,
          ],
        },
      },
      {
        path: 'quadros-personalizados',
        name: 'configuracoesQuadrosPersonalizadosView',
        component: () => import('../views/configuracoes/quadrosPersonalizados/QuadrosPersonalizados.vue'),
        meta: { auth: true },
      },
      {
        path: 'configurar-quadro-personalizado/:quadroId?',
        name: 'configuracoesQuadrosPersonalizadosConfigurarView',
        component: () => import('../views/configuracoes/quadrosPersonalizados/ConfigurarQuadro.vue'),
        meta: { auth: true },
      },
      {
        path: 'inteligencia-artificial',
        name: 'configuracoesInteligenciaArtificialView',
        component: () => import('../views/configuracoes/ConfiguracaoIa.vue'),
        meta: { auth: true },
      },
    ],
  },
  {
    path: '/campanhas',
    name: 'ListaCampanhas',
    component: () => import('../views/sugestoesCampanhas/ListaCampanhas.vue'),
    meta: { auth: true },
  },
  {
    path: '/campanhas/:campanhaId/respostas',
    name: 'ListaRespostas',
    component: () => import('../views/sugestoesCampanhas/ListaRespostas.vue'),
    meta: { auth: true },
    props: true,
  },
  {
    path: '/dashboard',
    name: 'dashboardHome',
    component: () => import('../views/dashboard/DashboardHome.vue'),
    meta: { auth: true },
  },
  {
    path: '/pacientes/:pacienteId/cartao-vacinas',
    name: 'CartaoVacinas',
    component: () => import('../views/imunizacao/CartaoVacinas.vue'),
    meta: {
      auth: true,
      permissions: [
        PermissoesPadrao.PacienteRead,
      ],
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  linkExactActiveClass: 'active',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to: Route, from: Route, next: NavigationGuardNext) => {
  const token: string | null = getToken();

  // Rotas públicas (sem token de app): fluxos do paciente gated por token assinado na URL.
  const rotasPublicas = [
    'login', 'recuperarSenha', 'confirmaEmail', 'confirmaAgendamento', 'redefinirSenha',
    'loginPaciente', 'meusAcessos', 'responderNps', 'prontuarioCompartilhado',
    'confirmarDoses', 'responderAnamnese', 'teleconsulta',
  ];
  if (!rotasPublicas.includes(to.name as string) && !token) {
    next('/login');
  } else if (to.meta && to.meta.permissions) {
    const userPermissions: string[] = getUserPermissions(token);
    const requiredPermissions: string[] = to.meta.permissions as string[];

    let hasAccess: boolean;

    if (requiredPermissions.includes(PermissoesPadrao.AcessoTriagem)) {
      hasAccess = requiredPermissions.every((item) => userPermissions.includes(item));
    } else {
      hasAccess = userPermissions.some((permission) => requiredPermissions.includes(permission));
    }

    if (hasAccess) {
      next();
    } else {
      AlertaSimples('Acesso não autorizado', 'Você não possui permissão para acessar esta página', 'warning');
      next('/home');
    }
  } else {
    next();
  }
});


const rotasParaForm = [
  'pacientesForm',
  'conveniosForm',
  'clinicasForm',
  'atendimentoForm',
  'usuario',
  'pacientesFormUpdate',
  'clinicasFormUpdate',
  'conveniosFormUpdate',
  'atendimentoFormUpdate',
  'impressosPersonalizadosForm',
  'impressosPersonalizadosFormUpdate',
];

const naoPermitirParaRotas = [
  'home',
  'login',
  'pacientes',
  'convenios',
  'Agenda',
  'clinicas',
  'usuarios',
  'atendimentos',
  'consultasPersonalizadas',
  'quadrosCustomizados',
  'triagem',
];


let confirmNavigation = true;

const storedNavigation = sessionStorage.getItem('confirmNavigation');
if (storedNavigation !== null) {
  confirmNavigation = storedNavigation === 'true';
}

window.addEventListener('beforeunload', (e) => {
  if (confirmNavigation && !naoPermitirParaRotas.includes(router.currentRoute.name)) {
    e.preventDefault();
    e.returnValue = '';
  }
});

router.beforeEach(async (to, from, next) => {
  if (rotasParaForm.includes(from.name)) {
    if (!to.params.liberar) {
      if (confirmNavigation && !(await AlertaPerguntaSimOuNaoBooleano('É possível que as alterações feitas não sejam salvas. Deseja sair?'))) {
        return false;
      }
      confirmNavigation = false;
      sessionStorage.setItem('confirmNavigation', String(confirmNavigation));
      next();
    } else {
      confirmNavigation = false;
      sessionStorage.setItem('confirmNavigation', String(confirmNavigation));
      next();
    }
  } else {
    confirmNavigation = true;
    sessionStorage.setItem('confirmNavigation', String(confirmNavigation));
    next();
  }
});

export default router;
